import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbaServidor, AtalhoDashboardServidor } from '../../core/rotas/navegacao-servidor';

@Component({
  selector: 'app-painel-dashboard-servidor',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './painel-dashboard-servidor.component.html',
  styleUrls: ['./painel-dashboard-servidor.component.css']
})
export class PainelDashboardServidorComponent {
  @Input() identificacao = '';
  @Input() atalhos: AtalhoDashboardServidor[] = [];
  @Output() selecionar = new EventEmitter<AbaServidor>();
}
